module.exports = __webpack_public_path__ + "img/usd.902d8464.svg";